import SimpleLightbox from "simplelightbox";
import Slider from "./slider";

export default class Lightbox {
    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            const imagesWithLightbox = document.querySelectorAll('.image--with-lightbox');
            if (imagesWithLightbox.length === 0) {
                return;
            }

            const lightboxIds = Array.from(imagesWithLightbox).map((image) => image.getAttribute('rel'));
            const uniqueLightboxIds = [...new Set(lightboxIds)];

            window.lightboxes = [];
            uniqueLightboxIds.forEach((lightboxId) => {
                let lightbox = new SimpleLightbox(`.image--with-lightbox[rel="${lightboxId}"]`, {
                    captionSelector: 'self', // get caption from title tag in link
                    overlayOpacity: 0.9
                });

                let attachedSlider = Slider.getByElement(document.querySelector(`.glide[data-lightbox-id="${lightboxId}"]`));
                if (attachedSlider) {
                    lightbox.on('show.simplelightbox', () => {
                        attachedSlider.slider.pause();
                    });

                    lightbox.on('next.simplelightbox', () => {
                        attachedSlider.slider.go('>');
                    });

                    lightbox.on('prev.simplelightbox', () => {
                        attachedSlider.slider.go('<');
                    });

                    lightbox.on('close.simplelightbox', () => {
                        attachedSlider.slider.play();
                    });
                }

                window.lightboxes.push(lightbox);
            });
        });
    }
}
